const currency = [
  { id: 1, name: 'MXN', code: 'MXN' },
  { id: 2, name: 'USD', code: 'USD' },
  { id: 3, name: 'RMB', code: 'CNY' }
]

export default currency
